"use strict";
var $ = require("../internals/export");
var globalThis = require("../internals/global-this");
var microtask = require("../internals/microtask");
var aCallable = require("../internals/a-callable");
var validateArgumentsLength = require("../internals/validate-arguments-length");
var fails = require("../internals/fails");
var DESCRIPTORS = require("../internals/descriptors");
var WRONG_ARITY = fails(function() {
  return DESCRIPTORS && Object.getOwnPropertyDescriptor(globalThis, "queueMicrotask").value.length !== 1;
});
$({ global: true, enumerable: true, dontCallGetSet: true, forced: WRONG_ARITY }, {
  queueMicrotask: function queueMicrotask(fn) {
    validateArgumentsLength(arguments.length, 1);
    microtask(aCallable(fn));
  }
});
